module.exports = __webpack_public_path__ + "static/media/about-left-image.6f36c18f.png";